var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionUnderlinedControl(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9,3.13V0H12.84V3.13H9.09V20.54a11.13,11.13,0,0,0,.36,3A4.81,4.81,0,0,0,12.72,27a9.93,9.93,0,0,0,3.19.45A10.25,10.25,0,0,0,19.28,27a5,5,0,0,0,2.16-1.4,5.27,5.27,0,0,0,1.15-2.26,12.49,12.49,0,0,0,.35-3.08V3.13H19.18V0H31.1V3.13H27.16q0,3.15,0,6.08c0,1.95,0,3.71,0,5.28s0,2.87,0,3.93,0,1.75,0,2.07a12,12,0,0,1-.89,4.87,9,9,0,0,1-2.39,3.27,9.26,9.26,0,0,1-3.5,1.84,15.31,15.31,0,0,1-4.22.57,15.53,15.53,0,0,1-5.76-.9A8.82,8.82,0,0,1,7,27.77a8.05,8.05,0,0,1-1.72-3.38,16.62,16.62,0,0,1-.46-3.95v-1c0-.55,0-1.24,0-2.06s0-1.74,0-2.75,0-2.05,0-3.09,0-2.05,0-3V3.13ZM0,36V33.3H32V36Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionUnderlinedControl);
export default __webpack_public_path__ + "static/media/tredition-underlined-control.b0d00815e11f95c740a2cb4943453b0b.svg";
export { ForwardRef as ReactComponent };